import { useEffect, useId, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import {
  addKeywords,
  getKeywords,
  getScrapedContent,
  initialScrape,
  removeKeyword
} from 'store/slices/socialScraping.slice';
import { RootState } from "store/store";
import { SocialScrapingFilterOptions } from 'types/scraping/socialScraping.type';
import { toastHelper } from 'utils/helper';
import { infoMessages, successMessages } from 'utils/message';

export const useSocialIntent = ({ page, limit }: { page: number, limit: number }) => {
  const dispatch = useAppDispatch();
  const socialScraping = useAppSelector((state: RootState) => state.socialScraping);
  const content = useAppSelector((state: RootState) => state.socialScraping.scraping);
  const toastId = useId()
  const [searchParams,] = useSearchParams()
  const [filetrsApplyed, setFiletrsApplyed] = useState<{ [key: string]: string }>({})

  const addNewKeywords = async (newKeywords: string[]) => {
    toastHelper({ message: infoMessages.SAVING_DATA, toastId: toastId, type: 'info' });
    try {
      await dispatch(addKeywords({
        keywords: newKeywords,
      }));
      await dispatch(getKeywords());
      toastHelper({ message: successMessages.ADD_SUCCESS, toastId: toastId, type: 'success' });
    } catch (error) {
      console.error("Error adding keywords:", error);
    }
  };
  const deleteKeyword = async (keywordId: string) => {
    toastHelper({ message: infoMessages.DELETING_DATA, toastId: toastId, type: 'info' });
    try {
      await dispatch(removeKeyword({
        keywordId,
      }));
      await dispatch(getKeywords());
      toastHelper({ message: successMessages.DELETE_SUCCESS, toastId: toastId, type: 'success' });
    } catch (error) {
      console.error("Error removing keyword:", error);
    }
  };
  const handleStartScrap = async () => {
    try {
      await dispatch(initialScrape());
    } catch (error) {

    }
  }
  const loadContent = () => {
    const filterApplyed = getSearchParams()
    const keywords = filterApplyed?.filters?.keywords !== '' && filterApplyed?.filters?.keywords?.map((item: { value: string } | string) => {
      return typeof (item) === 'string' ? item : item.value
    })
    const platform = filterApplyed?.filters?.platform !== '' && filterApplyed?.filters?.platform?.map((item: { value: string } | string) => {
      return typeof (item) === 'string' ? item : item.value
    })
    const options: SocialScrapingFilterOptions = {
      page,
      limit,
      keyword: keywords,
      platform
    };
    dispatch(getScrapedContent({ options }));
  };
  function getSearchParams() {
    const keywords = searchParams.get('keywords')
    const platform = searchParams.get('platform')
    setFiletrsApplyed({
      keywords: keywords ? JSON.parse(keywords) : null,
      platform: platform ? JSON.parse(platform) : null,
    })
    return {
      filters: {
        keywords: keywords ? JSON.parse(keywords) : null,
        platform: platform ? JSON.parse(platform) : null,
      }
    }
  }

  useEffect(() => {
    dispatch(getKeywords())
  }, []);
  useEffect(() => {
    loadContent()
  }, [page, searchParams]);

  return {
    data: socialScraping.content.data,
    isLoadingContent: socialScraping.content.isLoading,
    isLoadingKeywords: socialScraping.keywords.isLoading,
    totalItems: socialScraping.content.total,
    actualShowingPage: page * limit,
    isLastPage: socialScraping.content.total <= page * limit,
    keywords: socialScraping.keywords.data,
    keywordsLoading: socialScraping.keywords.isLoading,
    isScraping: content.isLoading,
    filetrsApplyed,
    addNewKeywords,
    deleteKeyword,
    handleStartScrap
  };
};
